/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timezone_Asia_Jerusalem2Inputs */

const he_timezone_asia_jerusalem2 = /** @type {(inputs: Timezone_Asia_Jerusalem2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jerusalem`)
};

const en_timezone_asia_jerusalem2 = /** @type {(inputs: Timezone_Asia_Jerusalem2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jerusalem`)
};

/**
* | output |
* | --- |
* | "Jerusalem" |
*
* @param {Timezone_Asia_Jerusalem2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const timezone_asia_jerusalem2 = /** @type {((inputs?: Timezone_Asia_Jerusalem2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timezone_Asia_Jerusalem2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_timezone_asia_jerusalem2(inputs)
	return en_timezone_asia_jerusalem2(inputs)
});
export { timezone_asia_jerusalem2 as "timezone_Asia_Jerusalem" }